import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import { ActionInterface } from "../../Interface/ActionInterface";
import Translator from "../../Translation/Translator";

export default function* paymentLink(action: ActionInterface): any {
  try {
    yield put({
      type: Constants.GLOBAL_PAYMENT_LINK_REQUEST
    });

    yield call(Http.put, `payment/${action.payload?.payment?.id}/link`, {
      chargeIds: action.payload?.chargeIds
    });

    yield put({
      type: Constants.GLOBAL_PAYMENT_LINK_SUCCESS
    });

    yield put({
      type: Constants.GLOBAL_CHARGES_LIST_OUTDATE_REQUESTS
    })

    yield put({
      type: Constants.GLOBAL_PAYMENTS_LIST_OUTDATE_REQUESTS
    })

    yield put({
      type: Constants.SNACKBAR_ADD_MESSAGE,
      payload: {
        message: Translator.trans("snackbar-message-payment-linked-successfully"),
        type: "success"
      }
    });

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this);
    }
  } catch (err) {
    yield ErrorHandlerSequence(err, action);

    yield put({
      type: Constants.GLOBAL_PAYMENT_LINK_FAILURE,
      payload: {
        err: err
      }
    });
  }
}

export function* watchPaymentLink() {
  yield takeEvery(Constants.GLOBAL_PAYMENT_LINK_START, paymentLink);
}
